export class FetchError extends Error {
    url: RequestInfo | URL;
    options?: RequestInit | undefined;
    constructor(args: Parameters<typeof fetch>, options?: ErrorOptions | undefined) {
        super(`Fetch error: ${args[1]?.method || ''} ${args[0]}`, options);
        this.url = args[0];
        this.options = args[1];
    }
}

const fetchHandler = {
    async apply(target: typeof fetch, thisArg: unknown, args: Parameters<typeof fetch>) {
        try {
            return await target(...args);
        } catch (err) {
            if (err instanceof Error) {
                throw new FetchError(args, { cause: err.constructor.name });
            }
            throw err;
        }
    },
};

const fetchProxy = new Proxy(fetch, fetchHandler) as typeof fetch;

/** Wrapped fetch method, that enrich fetch errors with url and options. */
export default fetchProxy;
